import { IsAsyncIterable } from '../../../../../../helpers';
export function GenerateFiniteStateObservableHookFromIterableWithPauseWorkflow(iterable, isAsync = IsAsyncIterable(iterable)) {
    return function (context) {
        let iterator;
        let state = 'paused';
        const pause = () => {
            if (state === 'iterating') {
                state = 'paused';
            }
        };
        const generator = iterable[isAsync ? Symbol.asyncIterator : Symbol.iterator];
        let resume;
        if (isAsync) {
            resume = (async () => {
                if (state === 'paused') {
                    state = 'iterating';
                    let result;
                    try {
                        while ((state === 'iterating') && !(result = await iterator.next()).done) {
                            context.next(result.value);
                        }
                        if (state === 'iterating') {
                            context.complete();
                        }
                    }
                    catch (error) {
                        context.error(error);
                    }
                    if (state === 'iterating') {
                        state = 'complete';
                    }
                }
            });
        }
        else {
            resume = (() => {
                if (state === 'paused') {
                    state = 'iterating';
                    let result;
                    try {
                        while ((state === 'iterating') && !(result = iterator.next()).done) {
                            context.next(result.value);
                        }
                        if (state === 'iterating') {
                            context.complete();
                        }
                    }
                    catch (error) {
                        context.error(error);
                    }
                    if (state === 'iterating') {
                        state = 'complete';
                    }
                }
            });
        }
        return {
            onObserved() {
                const instance = this;
                if ((iterator === void 0)
                    && (instance.observers.length === 1)
                    && (instance.state === 'next')) {
                    iterator = generator.call(iterable);
                }
                if (instance.observers.length > 0) {
                    resume();
                }
            },
            onUnobserved() {
                const instance = this;
                if ((!instance.observed)
                    && (instance.state === 'next')) {
                    pause();
                }
            },
        };
    };
}
//# sourceMappingURL=hook-generators.js.map